<div class="auth-layout">
  <div class="auth-card-wrapper">
    <p-card class="auth-card">
      <img src="assets/layout/images/logo.png" alt="logo" />
      <div class="auth-form">
        <router-outlet></router-outlet>
      </div>
    </p-card>
  </div>
</div>
